import React, { createContext, useContext } from "react";
import { PortalRole } from "./portalAccess";

const PortalRoleContext = createContext<PortalRole | null>(null);

export function PortalRoleProvider({
  role,
  children,
}: {
  role: PortalRole;
  children: React.ReactNode;
}) {
  return (
    <PortalRoleContext.Provider value={role}>
      {children}
    </PortalRoleContext.Provider>
  );
}

export function usePortalRole() {
  return useContext(PortalRoleContext);
}
